import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-star-white',
  templateUrl: './icon-star-white.component.html',
  styles: []
})
export class IconStarWhiteComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
